<template>
  <div class="box pb-90">
    <!-- 驻站专家申请表 -->

    <div class="card mt-47">
      <div class="t1">
        {{ $t('驻站专家信息申请表') }}
      </div>
      <div class="prompt df fww pr-36" v-if="promptFlog">
        <span class="iconfont c-them fs-18 mr-9 fn">&#xe66c;</span>
        <div class="f1 df fww">
          <span>1、{{ $t('在职公司、职位信息和真实照片，确认授权后会展示在OceanClub网页驻站专家墙；') }}</span>
          <span>2、{{ $t('邮箱及手机信息不会对外开放，仅做线下沟通和联系；') }}</span>
        </div>

        <span class="iconfont close" @click="promptFlog = false">&#xe6e5;</span>
      </div>

      <el-form :model="ruleForm" :inline="true" label-width="155px" :rules="rules" ref="ruleForm" class="mt-14">
        <el-form-item label-width="auto" prop="tesa_company_show" style="width: 100%;">
          <div class="df">
            <span class="c-59 fs-14 harmonyos-text mr-18">{{ $t('是否同意将公司名称信息展示于前台界面') }}</span>
            <el-checkbox-group name="tesa_company_show">
              <el-switch v-model="ruleForm.tesa_company_show" active-value="10" inactive-value="20"
                active-color="#B7251E" inactive-color="#C9C9C9">
              </el-switch>
            </el-checkbox-group>
          </div>
        </el-form-item>


        <div class="line">
          <el-form-item :label="$t('姓名')" prop="tesa_name" style="width: calc(33.33% - 7px);">
            <el-input v-model="ruleForm.tesa_name" :placeholder="$t('请输入姓名')" maxlength="50"
              name="tesa_name"></el-input>
          </el-form-item>
          <el-form-item v-if="tws_id == 1" :label="$t('姓名(英文)')" prop="locales_tesa_name" style="width: calc(33.33% - 7px);">
            <el-input v-model="ruleForm.locales_tesa_name" :placeholder="$t('请输入姓名(英文)')" maxlength="50"
              name="locales_tesa_name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('公司名称')" prop="tesa_company" style="width: calc(33.33% - 7px);">
            <el-input v-model="ruleForm.tesa_company" :placeholder="$t('请输入公司名称')" maxlength="100"
              name="tesa_company"></el-input>
          </el-form-item>
          <el-form-item  v-if="tws_id == 1" :label="$t('公司名称(英文)')" prop="locales_tesa_company" style="width: calc(33.33% - 7px);">
            <el-input v-model="ruleForm.locales_tesa_company" :placeholder="$t('请输入公司名称(英文)')" maxlength="100"
              name="locales_tesa_company"></el-input>
          </el-form-item>
          <el-form-item :label="$t('职位')" prop="tesa_position" style="width: calc(33.33% - 7px);">
            <el-select v-model="ruleForm.tesa_position" :placeholder="$t('请选择职位')" name="tesa_position">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in jobList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('电话')" prop="tesa_mobile" style="width: calc(33.33% - 7px);">
            <el-input v-model="ruleForm.tesa_mobile" :placeholder="$t('请输入电话')" maxlength="50"
              name="tesa_mobile"></el-input>
          </el-form-item>
          <el-form-item :label="$t('邮箱')" prop="tesa_email" style="width: calc(33.33% - 7px);">
            <el-input v-model="ruleForm.tesa_email" :placeholder="$t('请输入邮箱')" maxlength="50"
              name="tesa_email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('行业')" prop="tesa_industry" style="width: calc(33.33% - 7px);">
            <el-select v-model="ruleForm.tesa_industry" :placeholder="$t('请选择行业')" name="tesa_industry">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in industryList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item :label="$t('洲')" prop="tesa_district" style="width: calc(33.33% - 7px);">
            <el-select v-model="ruleForm.tesa_district" :placeholder="$t('请选择洲')" @change="handleDistrictChange"
                       name="tesa_district">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in cityList.region_list"
                         :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('国家/区域')" prop="tesa_country" style="width: calc(33.33% - 7px);">
            <el-select v-model="ruleForm.tesa_country" :placeholder="$t('请选择国家/区域')" @change="handleCountryChange"
                       name="tesa_country">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in cityList.country_list"
                         :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('省/州')" prop="tesa_province" style="width: calc(33.33% - 7px);">
            <el-select v-model="ruleForm.tesa_province" :placeholder="$t('请选择省/州')" @change="handleProvinceChange"
                       name="tesa_province">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in cityList.province_list"
                         :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('城市')" prop="tesa_city" style="width: calc(33.33% - 7px);">
            <el-select v-model="ruleForm.tesa_city" :placeholder="$t('请选择城市')" name="tesa_city">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in cityList.city_list"
                         :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('社区昵称')" prop="tesa_nickname" style="width: calc(33.33% - 7px);">
            <el-input v-model="ruleForm.tesa_nickname" :placeholder="$t('请输入社区昵称')" maxlength="50"
              name="tesa_nickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('生日')" prop="tesa_birthday" style="width: calc(33.33% - 7px);">
            <!--            <el-date-picker v-model="ruleForm.tesa_birthday" format="yyyy-MM-dd" type="date" :placeholder="$t('选择日期')"
              name="tesa_birthday">
            </el-date-picker>-->
            <el-select v-model="ruleForm.tesa_birthday" :placeholder="$t('选择日期')">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in monthList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('擅长领域')" prop="tesa_field" style="width: calc(33.33% - 7px);">
            <el-select v-model="ruleForm.tesa_field" :placeholder="$t('请选择擅长领域')" multiple name="tesa_field">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in fieldList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>
        </div>


       

          
      

        <div class="line">
          <el-form-item :label="$t('个人简介')" prop="tesa_biography" style="width: 100%;min-height: 120px;">
            <el-input v-model="ruleForm.tesa_biography" :placeholder="$t('请输入')" maxlength="5000" name="tesa_biography"
              type="textarea"></el-input>
          </el-form-item>
        </div>
        <div class="line-person">
          <el-form-item :label="$t('个人贡献') + '(' + $t('至少选两项') + ')'" prop="tesa_contribute"
            style="width: calc(100% - 206px);" class="df">
            <el-checkbox-group v-model="ruleForm.tesa_contribute" name="tesa_contribute">
              <el-checkbox name="tesa_contribute" :label="items.value" :value="items.value"
                v-for="(items, index) in contributeList" :key="index">{{ items.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="line">

          <el-form-item :label="$t('认证证书')" prop="tesa_authentication_certificate"
            style="width: 100%;min-height: 188px;">
            <div class="df" style="min-height: 188px;width: calc(100% - 438px)">
              <el-input v-model="ruleForm.tesa_authentication_certificate" maxlength="500"
                :placeholder="$t('IT类高级专家证书等，如有请从右侧上传相关截图')" type="textarea" class="f1" style=""></el-input>
            </div>
            <div style="width: 426px;min-height: 188px;position: absolute;right: 0;top: 0;" class="ml-12">
              <Uploadimg v-model="ruleForm.tesa_authentication_images" upType="IMGARR" :isUseOss="true" />
            </div>
          </el-form-item>
        </div>

        <div class="line">
          <el-form-item :label="$t('个人照片')" prop="tesa_personal_photo">
            <div style="width: 444px;min-height: 180px;">

              <Uploadcropper v-model="ruleForm.tesa_personal_photo"
                :fileType="['JPG', 'JPEG', 'PNG', 'png', 'jpeg', 'jpg']" name="tesa_personal_photo" :fileLimit="1"
                :fileSize="3" upType="IMGARR" :isUseOss="true" />
            </div>
            <div class="prompt-lins mt-14 df">
              <span class="iconfont">&#xe66c;</span>{{ $t('正面半身照，背景纯色，格式JPG,JPEG,PNG，大小不超过3M') }}
            </div>
          </el-form-item>
        </div>

      </el-form>
    </div>

    <div class="footer-box df aic jcc">
      <el-button class="btn1" @click="handleApplication()">{{ $t('取消') }}</el-button>
      <el-button class="btn2" @click="submitApply()">{{ $t('提交申请') }}</el-button>
    </div>

  </div>
</template>

<script>
import { getactivityGetArea } from "@api/active";
import { commonData, applyDetail, applySubmit } from "@api/expert";
import { getMyInfo } from "@api/home";
import Upload from "@comp/Upload/index.vue";
import Uploadimg from "@comp/Uploadimg/index.vue";
import Uploadcropper from "@comp/UploadCropper/index.vue";
export default {
  components: { Uploadimg, Upload, Uploadcropper },
  data() {
    return {
      promptFlog: true,
      str: '/cn',
      user_id: 0,
      tws_id: 1,
      ruleForm: {
        tesa_name: "",
        tesa_company: "",
        tesa_position: "",
        tesa_company_show: '10',
        tesa_mobile: "",
        tesa_email: "",
        tesa_industry: "",
        tesa_country: "",
        tesa_province: "",
        tesa_district: "",
        tesa_city: "",
        tesa_nickname: "",
        tesa_birthday: "",
        tesa_field: [],
        tesa_biography: "",
        tesa_contribute: [],
        tesa_authentication_certificate: "",
        tesa_authentication_images: [],
        tesa_personal_photo: [],
        locales_tesa_name: "",
        locales_tesa_company: "",
      },
      monthList: [],
      cityList: {
        region_list: [],
        country_list: [],
        province_list: [],
        city_list: [],
      },
      industryList: [],//行业
      jobList: [],//职位
      fieldList: [],//擅长领域
      contributeList: [],//个人贡献
      rules: {
        tesa_company_show: [
          { required: true, message: this.$t('请选择是否同意将公司名称信息展示于前台界面'), trigger: 'change' },
        ],
        tesa_name: [
          { required: true, message: this.$t("请输入姓名"), trigger: 'change' },
        ],
        tesa_company: [
          { required: true, message: this.$t('请输入公司名称'), trigger: 'change' },
          { max: 100, message: this.$t('最多输入100个字符'), trigger: 'change' }
        ],
        tesa_position: [
          { required: true, message: this.$t('请选择职位'), trigger: 'change' },
        ],
        tesa_mobile: [
          { required: true, message: this.$t('请输入电话'), trigger: 'change' },
        ],
        tesa_email: [
          { required: true, message: this.$t('请输入邮箱'), trigger: 'change' },
        ],
        tesa_industry: [
          { required: true, message: this.$t('请选择行业'), trigger: 'change' },
        ],
        tesa_field: [
          { required: true, message: this.$t('请选择擅长领域'), trigger: 'change' },
        ],
        tesa_biography: [
          { required: true, message: this.$t('请输入个人简介'), trigger: 'change' },
          { max: 5000, message: this.$t('最多输入5000个字符'), trigger: 'change' }
        ],
        tesa_personal_photo: [
          { required: true, message: this.$t('请上传个人照片'), trigger: 'change' },
        ],
        tesa_contribute: [
          { required: true, message: this.$t('请选择个人贡献'), trigger: 'change' },
          {
            required: true,
            message: this.$t("至少选两项"),
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value.length < 2) {
                callback(new Error(this.$t("至少选两项")));
              } else {
                callback();
              }
            },
          },
        ],
        tesa_district: [
          { required: true, message: this.$t('请选择洲'), trigger: 'change' },
        ],
        tesa_country: [
          { required: true, message: this.$t('请选择国家/区域'), trigger: 'change' },
        ],
        // tesa_province: [
        //   { required: true, message: this.$t('请选择省/州'), trigger: 'change' },
        // ],
        // tesa_city: [
        //   { required: true, message: this.$t('请选择城市'), trigger: 'change' },
        // ],
        name1: [
          { required: true, message: this.$t('请输入活动名称'), trigger: 'change' },
        ],
      }
    }
  },
  async mounted() {
    await this.getCommonData();
    this.getUserinfo();
    this.getcitytArea();
    // 获取 cookie 字符串
    const getCookieValue = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

// 解析 siteData cookie
    const siteDataCookie = getCookieValue('siteData');

    if (siteDataCookie) {
      // 将 cookie 值从字符串解析为对象
      const siteData = JSON.parse(decodeURIComponent(siteDataCookie));

      // 获取 tws_id
      this.tws_id = siteData.tws_id;
    }


    let Language = localStorage.getItem('currentLanguage');  //获取本地语言
    if (Language && Language != 'zh') {
      this.str = '/' + Language;
    }
  },
  methods: {

    /*初始化数据*/
    async getCommonData() {
      const res = await commonData();
      if (res.status == 200) {
        this.industryList = res.data.industry;
        this.jobList = res.data.job;
        this.fieldList = res.data.field;
        this.contributeList = res.data.contribute;
        this.monthList = res.data.month;
      }
    },
    handleDistrictChange() {
      // 更改洲后清空后续选项
      this.ruleForm.tesa_country = null;
      this.ruleForm.tesa_province = null;
      this.ruleForm.tesa_city = null;
      // 获取新的国家列表
      this.getcitytArea({
        act_region: this.ruleForm.tesa_district,
        act_country: 0,
        act_province: 0,
        act_city: 0,
      });
    },

    handleCountryChange() {
      // 更改国家后清空后续选项
      this.ruleForm.tesa_province = null;
      this.ruleForm.tesa_city = null;
      // 获取新的省列表
      this.getcitytArea({
        act_region: this.ruleForm.tesa_district,
        act_country: this.ruleForm.tesa_country,
        act_province: 0,
        act_city: 0,
      });
    },

    handleProvinceChange() {
      // 更改省后清空城市选项
      this.ruleForm.tesa_city = null;
      // 获取新的城市列表
      this.getcitytArea({
        act_region: this.ruleForm.tesa_district,
        act_country: this.ruleForm.tesa_country,
        act_province: this.ruleForm.tesa_province,
        act_city: 0,
      });
    },
    // 区域筛选
    async getcitytArea(obj = {}) {
      let res = await getactivityGetArea({ ...obj });

      if (res.status == 200) {
        this.cityList = res.data;
      }

    },
    isEmpty(value) {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else if (value && typeof value === 'object') {
        return Object.keys(value).length === 0;
      }
      return value === null || value === undefined;
    },
    async getUserinfo() {
      //let userinfo = JSON.parse(localStorage.getItem('userinfo'));
      let res = await getMyInfo();
      if (res.status == 200) {
        //如果在当前页退出了，返回专家列表页
        if (res.data.length == 0) {
          this.$router.push(this.str + '/stationed/index');
        }
        this.user_id = res.data.user_id;
        if (res.data.user_expert == 10) {
          //已经是驻站专家
          this.$router.push(this.str + '/stationed/info/' + res.data.user_id + '/60');
        }

        let details = await applyDetail();
        if (details.status == 200 && !this.isEmpty(details.data)) {
          let detailsData = details.data
          //this.ruleForm = detailsData;
          this.ruleForm.tesa_name = detailsData.tesa_name;
          this.ruleForm.tesa_company = detailsData.tesa_company;
          this.ruleForm.locales_tesa_name = detailsData.locales_tesa_name;
          this.ruleForm.locales_tesa_company = detailsData.locales_tesa_company;
          this.ruleForm.tesa_position = parseInt(detailsData.tesa_position)
          this.ruleForm.tesa_company_show = String(detailsData.tesa_company_show)
          this.ruleForm.tesa_mobile = detailsData.tesa_mobile;
          this.ruleForm.tesa_email = detailsData.tesa_email;
          this.ruleForm.tesa_country = detailsData.tesa_country > 0 ? detailsData.tesa_country : ''
          this.ruleForm.tesa_province = (detailsData.tesa_province > 0)?detailsData.tesa_province:''
          this.ruleForm.tesa_district = detailsData.tesa_district > 0 ? detailsData.tesa_district : ''
          this.ruleForm.tesa_city = (detailsData.tesa_city > 0)?detailsData.tesa_city:''
          this.ruleForm.tesa_nickname = detailsData.tesa_nickname;
          this.ruleForm.tesa_industry = parseInt(detailsData.tesa_industry)
          this.ruleForm.tesa_personal_photo = detailsData.tesa_personal_photo
          this.ruleForm.tesa_authentication_certificate = detailsData.tesa_authentication_certificate
          this.ruleForm.tesa_authentication_images = detailsData.tesa_authentication_images
          this.ruleForm.tesa_biography = detailsData.tesa_biography
          this.ruleForm.tesa_field = [];
          if (detailsData.tesa_field) {
            let trimmedString = detailsData.tesa_field.replace(/^[,\s]+|[,\s]+$/g, '');
            // 将字符串按空格分割成数组
            let resultArray = trimmedString.split(',').map(item => parseInt(item.trim()));
            this.ruleForm.tesa_field = resultArray
          }

          if (detailsData.tesa_contribute) {
            let trimmedString = detailsData.tesa_contribute.replace(/^[,\s]+|[,\s]+$/g, '');
            // 将字符串按空格分割成数组
            let resultArray = trimmedString.split(',').map(item => parseInt(item.trim()));
            this.ruleForm.tesa_contribute = resultArray
          } else {
            this.ruleForm.tesa_contribute = [];
          }
          this.ruleForm.tesa_birthday = detailsData.tesa_birthday;
          //this.ruleForm.tesa_birthday = detailsData.tesa_birthday > 0 ? new Date(detailsData.tesa_birthday * 1000) : ''
          let areaObj = {
            act_region: this.ruleForm.tesa_district,
            act_country: this.ruleForm.tesa_country,
            act_province: this.ruleForm.tesa_province,
            act_city: this.ruleForm.tesa_city,
          }
          this.ruleForm.act_city = this.ruleForm.tesa_city;
          this.getcitytArea(areaObj);
        } else {
          let data = res.data;
          this.ruleForm.tesa_name = data.user_name;
          this.ruleForm.tesa_nickname = data.user_nick_name;
          this.ruleForm.tesa_mobile = data.user_contact_mobile;
          this.ruleForm.tesa_email = data.user_contact_email;

          const findItem = this.industryList.find(item => item.value == parseInt(data.user_industry))
          this.ruleForm.tesa_industry = !findItem ? '' : parseInt(data.user_industry);
          this.ruleForm.tesa_birthday = data.user_birthday;
          this.ruleForm.tesa_company = data.user_company;
          this.ruleForm.tesa_position = data.user_job ? parseInt(data.user_job) : '';

          this.ruleForm.tesa_province = data.register_province > 0 ? data.register_province : ''
          this.ruleForm.tesa_country = data.register_country > 0 ? data.register_country : ''
          this.ruleForm.tesa_district = data.register_district > 0 ? data.register_district : ''
          this.ruleForm.tesa_city = data.register_city > 0 ? data.register_city : ''

          this.ruleForm.tesa_field = data.user_excel;
          if (data.user_excel) {
            let trimmedString = data.user_excel.replace(/^[,\s]+|[,\s]+$/g, '');
            // 将字符串按空格分割成数组
            let resultArray = trimmedString.split(',').map(item => parseInt(item.trim()));
            this.ruleForm.tesa_field = resultArray
          } else {
            this.ruleForm.tesa_field = [];
          }
          let areaObj = {
            act_region: this.ruleForm.tesa_district,
            act_country: this.ruleForm.tesa_country,
            act_province: this.ruleForm.tesa_province,
            act_city: this.ruleForm.tesa_city,
          }
          this.ruleForm.act_city = this.ruleForm.tesa_city;
          this.getcitytArea(areaObj);
        }

      }
    },
    //提交申请
    async submitApply() {
      var res;
      this.loading = true;

      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          let submitFormData = JSON.parse(JSON.stringify(this.ruleForm));

          /** 请求审核接口*/
          res = await applySubmit(submitFormData);
          this.loading = false;
          this.$forceUpdate();
          if (res.status != 200) return;
          this.$message({
            message: res.msg,
            type: "success",
          });
          //跳转主页
          setTimeout(() => {
            this.$router.push(this.str + '/stationed/info/' + this.user_id + '/60');
          }, 4000);
        } else {
          const firstErrorField = this.$refs.ruleForm.fields.find(field => field.validateState === 'error');
          const errorElement = document.getElementsByName(firstErrorField.prop)[0];
          if (errorElement) {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

      })


    },
    // 跳转申请页面
    async handleApplication() {
      if (window.history.length > 1) {
        // 如果有历史记录，返回上一页
        this.$router.go(-1);
      } else {
        // 如果没有历史记录，跳转到指定页面
        this.$router.push(this.str + '/stationed/index');
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.prompt-lins {
  border: 1px solid rgb(245, 245, 245);
  border-radius: 4px;
  background: rgb(245, 245, 245);
  padding: 13px 16px 13px 16px;

  color: rgb(25, 25, 25);
  font-family: "harmonyos";
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;


  .iconfont {
    font-size: 18px;
    color: #B7251E;
    margin-right: 9px;
  }
}


.footer-page {
  display: none;
}

::v-deep() {
  .el-checkbox {
    margin-right: 20px;
    min-width: 400px;
  }

  .footer-page {
    display: none;
  }

  // .el-form--inline .el-form-item {
  //   margin-right: 24px;

  // }

  .line {
    .el-form-item:nth-child(3n) {
      margin-right: 0;

    }

    .el-textarea__inner {
      min-height: 120px !important;
      height: 100%;
    }

  }

  .line-person {

    .el-form-item__content {
      max-width: 940px;
    }

    .el-checkbox {
      min-width: calc(50% - 20px);
    }
  }

  .el-form--inline .el-form-item__label {
    color: rgb(89, 89, 89);
    font-family: "harmonyos";
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
  }

  .el-form-item__content {
    line-height: 28px;
    width: calc(100% - 155px);
  }

  .el-select,
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .el-input__inner {
    line-height: 28px;
    height: 28px;
  }

  .el-input__icon {
    line-height: 28px;
  }
}

.box {
  padding-left: 80px;
  padding-right: 80px;
  padding-top: 60px;

  .prompt {
    border-radius: 4px;
    background: rgb(245, 245, 245);
    padding: 13px 16px 13px 16px;
    color: rgb(25, 25, 25);
    font-family: "harmonyos";
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-top: 26px;
    position: relative;

    .close {
      position: absolute;
      right: 0;
      top: 12px;
      right: 16px;
      font-size: 17px;
      cursor: pointer;
      color: #191919;
    }



  }

  .t1 {
    text-align: center;
    color: rgb(25, 25, 25);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 32px;
    font-weight: 400;
    line-height: 36px;
  }

  .footer-box {
    width: 100%;
    box-shadow: 0px -8px 24px 0px rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
    height: 91px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 66;

    .btn1,
    .btn2 {
      box-sizing: border-box;
      min-width: 156px;
      height: 40px;
      border-radius: 23px;
      padding: 0 16px;
      font-size: 14px;
      border-radius: 23px;
    }

    .btn1 {

      border: 1px solid rgb(0, 0, 0);
      color: rgb(0, 0, 0);

      &:hover {
        border: 1px solid #B7251E;
        color: #B7251E;
      }
    }

    .btn2 {
      background: rgb(183, 37, 30);
      color: #ffffff;

      &:hover {
        background: #DD736D;
      }
    }

    .el-button+.el-button {
      margin-left: 16px;
    }
  }

  .card {
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.08);
    background: rgb(255, 255, 255);
    padding: 24px 32px 24px;
    max-width: 1752px;
    margin: 0 auto;
  }
}
</style>